import { useEffect, useRef, useState } from "react"
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CreditProcessMovement, _IncomeDocument, _LoanConfigProfile, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { DropDown } from "../../../../theme/Component/DropDown";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectIncomeStateConstant } from "../../../../Treasury/IncomeDocument/Components/SelectIncomeStateConstant";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { Modal } from "../../../../theme/Component/Modal";
import AutoChart from "../../../../../core/graph/AutoChart";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { FileService } from "../../../../../core/services/FileService";
import { IncomeCompensationDocument } from "../../../../Treasury/IncomeDocument/IncomeCompensationDocument/IncomeCompensationDocument";
import { ComponentCreditosDisponiblesDescuentoNominaTercero } from "../../../../custom/forpo/components/Credit/Procesos/ComponentCreditosDisponiblesDescuentoNominaTercero";
import { SelectTypeProcees } from "../../PaymentAccount/SelectTypeProcees";
import { CustomProcessTypeSeleect } from "../../../../erp/cellEditor/CustomProcessType/CustomProcessTypeSeleect";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectAccountantConceptCatalogByProcess } from "./AccountantConceptCatalogByProcess/SelectAccountantConceptCatalogByProcess";
import { FileInput } from "../../../../theme/Component/FileInput";
import { BudgetAccountantOperationSelect } from "../../../../erp/cellEditor/BudgetAccountantOperation/BudgetAccountantOperationSelect";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { _CreateEgress, _IncomeAdjustment, _IncomeAdjustmentByValue, _UpdateIcomeDoc } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { CatalogByIncomeResponsible } from "./DefineConceptCatalogCompensation/CatalogByIncomeResponsible/CatalogByIncomeResponsible";
import { SelectBusinessCore } from "../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { BankAccountSelect } from "../../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { IncomeCompensationAccount } from "../../../../Treasury/IncomeDocument/IncomeCompensationDocument/IncomeCompensationAccount";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { VisorDocumentFactory } from "../../../../documents/VisorDocumentFactory";
import { Alert } from "../../../../theme/Component/Alert";

interface dataTime {
    Day: number;
    Month: number;
    Year: number;
}

interface payParameters {
    AccountantDate: any;
    CustomProcessType: number;
    ProcessType: number;
    Media: string;
    IDBudgetAccountantOperation: number;
    MediaContext: string;
    DataStore?: string;
    Extra?: boolean;
}

interface formData {
    Year: number;
    Month: number;
    AccountantOperation: number;

}

export const ConceptCatalogByProcess = () => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_IncomeDocument);
    const _loan = useDataBean(_LoanConfigProfile);
    const createEgress = useDataBean(_CreateEgress);
    const UpdateIcomeDoc = useDataBean(_UpdateIcomeDoc);
    const IncomeAdjustment = useDataBean(_IncomeAdjustment);
    const IncomeAdjustmentByValue = useDataBean(_IncomeAdjustmentByValue);
    const fileService = new FileService();
    const paginador = usePaginator();


    const [date, setDate] = useState<Partial<dataTime>>({});
    const [funcionario, setFuncionario] = useState<number>(null);
    const [state, setState] = useState<number>(null);
    const [regexStr, setregexStr] = useState<any>(null);

    const [param, setParam] = useState<Partial<payParameters>>({})

    const [form, setForm] = useState<Partial<formData>>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
    })

    const modalTercero = useModal("Tercero", MODAL_XL);
    const doAfter = useModal("Tareas", MODAL_SM);
    const compensar = useModal("Compensar Pago con Cuotas de Crédito", MODAL_md);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const compensarByFile = useModal("Compensar Pago con Cuotas de Crédito desde Archivo", MODAL_md);
    const applyPays = useModal("Aplicar Pagos a Cuotas de Crédito", MODAL_md);
    const applyPaysUno = useModal("Aplicar Pagos a Cuotas de Crédito", MODAL_md);
    const [modalrealizar, setModalrealizar] = useState<any>({ name: 'Realizar Pago de Compensación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgeneratecomp, setModalgeneratecomp] = useState<any>({ name: 'Generar compensación por ajuste al peso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerate, setModalgenerate] = useState<any>({ name: 'Generar compensación de ingreso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [modalconsultar, setModalconsultar] = useState<any>({ name: 'Consultar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [uno, setUno] = useState<any>({});
    const modalIAD = useModal("Documento", MODAL_XL);

    useEffect(() => {
        getListaExport();
    }, [paginador.page])


    const getListaExport = () => {
        instance.getIncomeDocumentCatalogvdos(
            form.Year,
            form.Month,
            form.AccountantOperation,
            null,
            funcionario,
            null,
            state,
            regexStr,
            paginador.page,
            1000
        ).then((resp) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);

                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityDoc = `${element.DataBeanProperties.Mnemonic ?? "N/A"} - ${element.DataBeanProperties.Consecutive ?? "N/A"}`;
                    element.DataBeanProperties.EntityACMDoc = `${element.DataBeanProperties.ACMMnemonic ?? "N/A"} - ${element.DataBeanProperties.ACMConsecutive ?? "N/A"}`;
                    element.DataBeanProperties.EntityBudget = `${element.DataBeanProperties.BudgetIDStr ?? "N/A"} - ${element.DataBeanProperties.BudgetIDName ?? "N/A"}`;
                    element.DataBeanProperties.EntityAccountant = `${element.DataBeanProperties.AccountantIDStr ?? "N/A"} - ${element.DataBeanProperties.AccountantIDName ?? "N/A"}`;
                    element.DataBeanProperties.DocumentYear = element.DataBeanProperties.DocumentDate.split('-')[0] ? Number(element.DataBeanProperties.DocumentDate.split('-')[0]) : null;

                    if (element.DataBeanProperties.LoanMediaContext) {
                        element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.LoanMediaContext, element.DataBeanProperties.LoanMedia)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                    } else {
                        element.DataBeanProperties.URL = "Sin Documento";
                    }
                });

                setLista(resp.List);
            }
        }).catch((err) => {
            console.log(err);
        });
    };
    const updateIncomeDocumentState = () => {
        UpdateIcomeDoc.instance.updateIncomeDocumentState(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                if (resp) {
                    console.log(resp)

                    toast.success('Actualizado')
                    // setModalactualizar({ ...modalactualizar, view: false });

                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const createDocumentIncomeAdjustment = () => {
        IncomeAdjustment.instance.createDocumentIncomeAdjustment(bean.IDIncomeDocument, bean.DocumentDate, IncomeAdjustment.bean.AccountantDate, IncomeAdjustment.bean.IDAccount, IncomeAdjustment.bean.IDBusinessCore, IncomeAdjustment.bean.IDProject, IncomeAdjustment.bean.Description, _single.getAccountID(), true).then(
            (resp) => {
                if (resp) {
                    setDocument(resp.DocumentURL);
                    toast.success('Documento generado');
                    setModalgeneratecomp({ ...modalgeneratecomp, view: false });
                    modalDocumento.open("Documento de compensación por ajuste al peso");
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const createDocumentIncomeAdjustmentByValue = () => {
        IncomeAdjustmentByValue.instance.createDocumentIncomeAdjustmentByValue(bean.IDIncomeDocument, bean.DocumentYear, IncomeAdjustmentByValue.bean.AccountantDate, IncomeAdjustmentByValue.bean.IDIncomeResponsibleConcept, IncomeAdjustmentByValue.bean.IDAccount, IncomeAdjustmentByValue.bean.IDBusinessCore, IncomeAdjustmentByValue.bean.IDProject, IncomeAdjustmentByValue.bean.Description, IncomeAdjustmentByValue.bean.Value, _single.getAccountID(), true).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    setDocument(resp.DocumentURL)
                    toast.success('Creado')
                    setModalgenerate({ ...modalgenerate, view: false });
                    modalDocumento.open("Ver Compensacion de Ingreso");
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const doAfterSaveActionForIncomeCompensationDocument = () => {

        if (bean.IDDocument && bean.DocumentDate) {
            instance.doAfterSaveActionForIncomeCompensationDocument(bean.IDDocument, bean.DocumentDate).then(
                (resp: any) => {
                    toast.success("Tarea Ejecutada");
                }
            )
        } else {
            toast.warning("Faltan Parametros");
        }


    }

    const createEgressDocumentForIncomeDocument = () => {
        if (!bean.IDDocument) {
            toast.warning("Debe tener un Doumento.");
            return;
        }
        if (!bean.DocumentDate) {
            toast.warning("Debe tener una Fecha de Documento.");
            return;
        }
        if (!createEgress.bean.AccountantDate) {
            toast.warning("Debe seleccionar una Fecha Contabilización.");
            return;
        }
        if (!createEgress.bean.IDAccount) {
            toast.warning("Debe seleccionar un Beneficiario del Pago.");
            return;
        }
        if (!createEgress.bean.IDBankingAccount) {
            toast.warning("Debe seleccionar una Entidad.");
            return;
        }
        if (!createEgress.bean.ToCompensateValue) {
            toast.warning("Debe seleccionar un Valor a Girar.");
            return;
        }
        createEgress.instance.createEgressDocumentForIncomeDocument(bean.IDDocument, bean.DocumentDate, createEgress.bean.AccountantDate, createEgress.bean.IDAccount, null, createEgress.bean.IDBankingAccount, createEgress.bean.ToCompensateValue, createEgress.bean.Description, _single.getAccountID()).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    setDocument(resp.DocumentURL)
                    toast.success('Creado')
                    setModalrealizar({ ...modalrealizar, view: false });
                    modalDocumento.open("Pago de Compensación");
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [

        { title: 'Fecha', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Concepto', property: 'AccountantConceptName', visible: true },
        { title: 'Documento Ingreso', property: 'EntityDoc', visible: true },
        { title: 'Valor de Ingreso', property: 'Value', visible: true, mask: MASK_MONEY },
        // { title: 'Importe', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Nit Fuente de Ingreso', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero Fuente de Ingreso', property: 'AccountName', visible: true },
        { title: 'No. Crédito', property: 'LoanNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Valor Compensado', property: 'CompensatedValue', visible: true, mask: MASK_MONEY },
        { title: 'Aplicar Compensación de Credito', property: 'ApplyLoanCompensation', visible: true },
        { title: 'Cuenta', property: 'EntityAccountant', visible: true },
        { title: 'Mensaje de Proceso de Compensación', property: 'LoanMessage', visible: true },
        { title: 'Referencia 1 Siif', property: 'Reference1', visible: true },
        { title: 'Referencia 2', property: 'Reference2', visible: true },
        { title: 'Referencia 3', property: 'Reference3', visible: true },
        { title: 'Documento Compensacion', property: 'EntityACMDoc', visible: true },
        { title: 'Consultar archivo de cargue masivo de créditos', property: 'URL', visible: true },
        // { title: 'No Crédito', property: 'IDLoanQuota', visible: true },
        // { title: 'Rubro', property: 'BudgetIDName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
        { id: 2, name: 'Aplicar Pagos a Cuotas de Crédito', permiso: null, activo: true },
    ];
    const validar = () => {
        createEgress.setBean({

        })
        setModalrealizar({ ...modalrealizar, view: true });
    }
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        } else if (e.id == 2) {
                            applyPays.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Comprobante de Ingreso', icono: 'ri-file-2-line', visible: true, evento: () => { modalIAD.open() } },
            { titulo: 'Compensación Pago de Crédito Individual', icono: 'ri-file-add-line', visible: true, evento: () => { creditsUno.current?.openModal() } },
            { titulo: 'Consultar Operaciones de Compensación', icono: 'ri-file-copy-line', visible: true, evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },
            { titulo: 'Consultar Terceros de la Compensación', icono: 'ri-contacts-book-line', visible: true, evento: () => { modalTercero.open() } },
            { titulo: 'Actualizar Estado', icono: 'ri-refresh-line', visible: true, evento: () => { updateIncomeDocumentState() } },
            { titulo: 'Compensar Pago con Cuotas de Crédito desde Archivo', icono: 'ri-attachment-line', visible: true, evento: () => { compensarByFile.open(); } },
            { titulo: 'Ejecutar tareas despues de Grabado', icono: 'ri-exchange-line', visible: true, evento: () => { doAfter.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const credits = useRef<any>(null);
    const creditsUno = useRef<any>(null);

    const setRowBean = (e: any) => {
        setBean(e);
        credits.current?.setEmployee(e);
    }

    useEffect(() => {
        if (bean.DocumentDate) {
            descomponerFecha(bean.DocumentDate)
        }
        credits.current?.setLista([]);
    }, [bean])

    function descomponerFecha(fechaStr) {
        const [fecha] = fechaStr.split(' ');
        const [anio, mes, dia] = fecha.split('-');

        setDate({
            Day: dia,
            Month: parseInt(mes) - 1,
            Year: anio
        })
    }

    const [listMove, setListMove] = useState<any[]>([]);
    const [document, setDocument] = useState<any>({});
    const modalDocumento = useModal("Documento", MODAL_XL);

    const setQuotaCreditForIncomeUnoaUno = () => {

        console.log(bean.IDDocument, bean.DocumentDate, credits.current?.IDLoanAccount, credits.current?.creditNumner, listMove, _single.getAccountID());

        setUno({
            IDDocument: bean.IDDocument,
            DocumentDate: bean.DocumentDate,
            IDLoanAccount: credits.current?.IDLoanAccount,
            CreditNumner: credits.current?.creditNumner,
            ListMove: listMove
        });
        applyPaysUno.open();

    }


    const applyPayments = () => {
        _loan.instance.parseQuotaCreditForAccountantConcept(form.Year, form.Month, form.AccountantOperation, param.CustomProcessType, param.AccountantDate, param.IDBudgetAccountantOperation, _single.getAccountID()).then(
            (resp) => {
                if (resp.ReportList) {
                    setDocument(resp.ReportList);
                    toast.success("Pago aplicado");
                    modalDocumento.open()
                    applyPays.close()
                } else {
                    toast.warning("Documento con novedades no se pudo aplicar");
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const applyPaymentsUnoAUno = () => {
        let movements = uno.ListMove;
        movements.forEach(element => {

            if (param.Extra === true)
                element.IgnorePayments = true;

            element.PaymentDate = param.AccountantDate;
            element.Description = `El dia ${bean.DocumentDate} Recibimos pago de ${bean.AccountName ?? 'Sin tercero'} por valor de ${bean.Value} referencias No. ${bean.Reference1}`;
        });


        console.log("MOVIMIENOTS PAGO");
        console.log(movements);

        // aplicar pago compensacion individual 
        _loan.instance.parseQuotaCreditForIncomeDocumentUno(form.Year, form.Month, uno.IDDocument, uno.DocumentDate, param.CustomProcessType,
            param.AccountantDate, param.IDBudgetAccountantOperation, movements, _single.getAccountID()).then(
                (resp) => {
                    if (resp.ReportList) {
                        setDocument(resp.ReportList);
                        toast.success("Pago aplicado");
                        modalDocumento.open("Pagos Aplicados")
                        applyPaysUno.close()
                    } else {
                        toast.warning("Documento con novedades no se pudo aplicar");
                    }
                }
            ).catch(err => { toast.error(err) });
    }

    const applyPaywithCredit = () => {
        _loan.instance.parseQuotaCreditForIncomeDocument(form.Year, form.Month, bean.IDDocument, bean.DocumentDate, param.CustomProcessType, param.AccountantDate, param.IDBudgetAccountantOperation, bean.IDLoanAccount, bean.LoanPaidedData ? JSON.parse(bean.LoanPaidedData) : [], _single.getAccountID()).then(
            (resp) => {
                if (resp.ReportList) {
                    setDocument(resp.ReportList);
                    toast.success("Pago aplicado");
                    modalDocumento.open("Pago Aplicado");
                    compensar.close()
                } else {
                    toast.warning("Documento con novedades no se pudo aplicar");
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const applyPaywithCreditByDoc = () => {
        _loan.instance.parseQuotaForFile(form.Year, form.Month, bean.IDDocument, bean.DocumentDate, param.CustomProcessType, param.AccountantDate, param.IDBudgetAccountantOperation, param.Media, param.MediaContext, param.DataStore, _single.getAccountID()).then(
            (resp) => {
                toast.success("Pago en proceso sera notificado al terminar el proceso");
                compensarByFile.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <BasicPage titulo="Compensación de Ingresos de Servicios Financieros">
            <div className="row">
                <div className="col-md-3">
                    <YearSelector tittle="Año" onChange={(e) => { setForm({ ...form, Year: e }) }} value={form.Year} />
                </div>
                <div className="col-md-3">
                    <MonthConstantsEditor name="" idSelect={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
                </div>
                <div className="col-md-3">
                    <SelectAccountantConceptCatalogByProcess returnType="ID" idSelector={form.AccountantOperation} onChange={(e) => { setForm({ ...form, AccountantOperation: e }) }} label="Concepto de Ingreso" />
                </div>
                <div className="col-md-3">
                    <AccountEditor idAccount={funcionario} onChange={(e) => { setFuncionario(e.IDAccount) }} label="Tercero" />
                </div>
                <div className="col-md-3">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-3">
                    <SelectIncomeStateConstant idSelector={state} onChange={(e) => { setState(parseInt(e)) }} />
                </div>
                <div className="col-md-3 mt-4">
                    <BasicButton icon="" eventClick={getListaExport}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={head} body={lista} rowSet={setRowBean} next={paginador.next} listButtons={listaBotones()} />


                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['AccountantConceptName', 'Rubro', 'DocumentDate', 'StateName']}
                            yOptions={['Value']} />

                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={modalconsultar} updateModal={setModalconsultar} >
                            <IncomeCompensationDocument IDDocument={bean.IDDocument} DocumentDate={bean.DocumentDate} />
                        </Modal>
                        <Modal modal={modalTercero.modal} updateModal={modalTercero.setModal} >
                            <IncomeCompensationAccount income={bean} />
                        </Modal>
                    </div>


                    <div className="col-md-12">
                        <Modal modal={applyPays.modal} updateModal={applyPays.setModal} eventModal={() => { applyPayments() }}  >
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.IDBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "IDBudgetAccountantOperation": e }) }} />
                                </div>

                            </div>
                        </Modal>
                        <Modal modal={applyPaysUno.modal} updateModal={applyPaysUno.setModal} eventModal={() => { applyPaymentsUnoAUno() }}  >
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.IDBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "IDBudgetAccountantOperation": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BasicSwitch label="Pago Extraordinario" estado={param.Extra ?? false} eventChange={(e) => { setParam({ ...param, "Extra": e }) }} />
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="col-md-12">
                        <Modal modal={compensarByFile.modal} updateModal={compensarByFile.setModal} eventModal={() => { applyPaywithCreditByDoc() }} >
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.IDBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "IDBudgetAccountantOperation": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <FileInput onCreate={(e) => { setParam({ ...param, Media: e.Media, MediaContext: e.MediaContext }) }} />
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="col-md-12">
                        <Modal modal={compensar.modal} updateModal={compensar.setModal} eventModal={() => { applyPaywithCredit() }} onSubmitLabel="Aplicar Pago">
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                                </div>
                                <div className="col-md-12">
                                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.IDBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "IDBudgetAccountantOperation": e }) }} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalrealizar} updateModal={setModalrealizar} eventModal={createEgressDocumentForIncomeDocument}>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={createEgress.bean.AccountantDate} setDate={(e) => { createEgress.setBean({ ...createEgress.bean, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <AccountEditor label="Tercero" idAccount={createEgress.bean.IDAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">

                                    <BankAccountSelect label='Entidad' idSelector={createEgress.bean.IDBankingAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDBankingAccount": e }) }} />
                                    {/* <BakingEntityEditor label="Entidad Bancaria" idSelector={createEgress.bean.IDBankingAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDBankingAccount": e }) }} /> */}
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _label="Valor a Girar" _value={createEgress.bean.ToCompensateValue} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "ToCompensateValue": e }) }} />

                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={createEgress.bean.Description} onChange={createEgress.handleChange} />

                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={createDocumentIncomeAdjustmentByValue}>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputDate label="Fecha Contabilización" name="AccountantDate" value={IncomeAdjustmentByValue.bean.AccountantDate} setDate={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "AccountantDate": e }) }} />
                                </div>
                                {/* <div className="col-md-6">
                                    <YearSelector tittle="Año" onChange={(e) => { setgeneratebean({ ...generatebean, "Year": e }) }} value={form.Year} />
                                </div> */}
                                <div className="col-md-6">
                                    <label>Concepto Contable de Ajuste</label>
                                    <CatalogByIncomeResponsible render={IncomeAdjustmentByValue.bean.IncomeResponsibleName} idSelector={IncomeAdjustmentByValue.bean.IDIncomeResponsibleConcept} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDIncomeResponsibleConcept": e.IDIncomeResponsibleConcept, "IncomeResponsibleName": e.Name, "IDBusinessCore": e.IDBusinessCore, "IDProject": e.IDProject }) }} label=" " returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <AccountEditor label="Tercero" idAccount={IncomeAdjustmentByValue.bean.IDAccount} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _value={IncomeAdjustmentByValue.bean.Value} onChange={(e: any) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, 'Value': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={IncomeAdjustmentByValue.bean.IDBusinessCore} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDBusinessCore": e.Code }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectProject label='Proyecto' idSelector={IncomeAdjustmentByValue.bean.IDProject} returnType="Object" onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDProject": e.IDProject }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={IncomeAdjustmentByValue.bean.Description} onChange={IncomeAdjustmentByValue.handleChange} />

                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalgeneratecomp} updateModal={setModalgeneratecomp} eventModal={createDocumentIncomeAdjustment}>
                            <div className="row">
                                <div className="col-md-12">
                                    <InputDate label="Fecha Contabilización" name="AccountantDate" value={IncomeAdjustment.bean.AccountantDate} setDate={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "AccountantDate": e }) }} />
                                </div>
                                {/* <div className="col-md-6">
                                    <YearSelector tittle="Año" onChange={(e) => { setgeneratebean({ ...generatebean, "Year": e }) }} value={form.Year} />
                                </div> */}
                                {/* <div className="col-md-6">
                                    <label>Concepto Contable de Ajuste</label>
                                    <CatalogByIncomeResponsible render={IncomeAdjustment.bean.IncomeResponsibleName} idSelector={IncomeAdjustment.bean.IDIncomeResponsibleConcept} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDIncomeResponsibleConcept": e.IDIncomeResponsibleConcept, "IncomeResponsibleName": e.Name, "IDBusinessCore": e.IDBusinessCore, "IDProject": e.IDProject }) }} label=" " returnType="Object" />
                                </div> */}
                                <div className="col-md-6">
                                    <AccountEditor label="Tercero" idAccount={IncomeAdjustment.bean.IDAccount} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={IncomeAdjustment.bean.IDBusinessCore} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDBusinessCore": e.Code }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectProject label='Proyecto' idSelector={IncomeAdjustment.bean.IDProject} returnType="Object" onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDProject": e.IDProject }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={IncomeAdjustment.bean.Description} onChange={IncomeAdjustment.handleChange} />

                                </div>
                            </div>
                        </Modal>
                        <Modal modal={modalIAD.modal} updateModal={modalIAD.setModal}>
                            <div className="row">
                                <div className="col-md-12">
                                    <VisorDocumentFactory Mnemonic={bean.Mnemonic} Consecutive={bean.Consecutive} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal} evenOnClose={() => { setDocument([]) }} >
                            {Array.isArray(document) && document.length > 0 ?
                                <DocumentViewer list={document} />
                                :
                                <Alert children={"No se geenero ningun documento"} clase="warning text-center" />
                            }
                        </Modal>

                        <ModalConfirm modal={doAfter.modal} updateModal={doAfter.setModal} eventModal={doAfterSaveActionForIncomeCompensationDocument}>
                            <p>Ejecutar Tareas</p>
                        </ModalConfirm>
                    </div>

                    <div className="col-md-12">
                        <ComponentCreditosDisponiblesDescuentoNominaTercero DocumentDate={bean.DocumentDate} idAccount={bean.IDAccountIncomeOwner} incomeAmmouunt={bean.Value} month={date.Month} year={date.Year} ref={creditsUno} onChange={(e) => { setListMove(e) }} eventModal={() => {
                            creditsUno.current?.closeModal();
                            setQuotaCreditForIncomeUnoaUno();
                        }} />
                    </div>
                </div>
            </div>
        </BasicPage>
    )
}